import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { bookingState } from '../client-state/booking-state-context';
import { loadBookingMinimalShop } from './data-loaders/shop-loader';

const useBookingMinimalShop = (enabled: boolean = true) => {
  const { state } = useContext(bookingState);

  return useQuery({
    queryKey: ['bookingMinimalShop', state.selectedShopId],
    queryFn: () => loadBookingMinimalShop(state.selectedShopId),
    enabled: enabled && Boolean(state.selectedShopId),
  });
};

export default useBookingMinimalShop;
